module.exports = __webpack_public_path__ + "static/media/34.203a6a11.png";